import { VerificationAdditionalCheckStatusEnum } from '@/enums';
import { CertificationsContainer } from '@/components/custom';
import { useUrlParams } from '../hooks';

const BodyPage = () => {

	const { gender } = useUrlParams();

	return (
		<CertificationsContainer
			additionalCheckStatus={VerificationAdditionalCheckStatusEnum.WITHOUT_STATE}
			gender={gender}
			run={!!gender} />
	);

};

export default BodyPage;
